const API_URL = window.ArmaTuPCConfig?.apiUrl || process.env.REACT_APP_API_URL;

const fetchProd = async (prod_id) => {
    let result;

    await fetch(`${API_URL}/producto/${prod_id}`, {
        headers: {
            'Content-type': 'application/json'
        },
        method: 'GET'
    }).then(async response => {
        result = await response.json();
    });

    return result;
}

export default fetchProd;